<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>场馆系统</el-breadcrumb-item>
        <el-breadcrumb-item>游泳馆</el-breadcrumb-item>
        <el-breadcrumb-item>场馆管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'stadiumInfo' }">场馆信息</el-breadcrumb-item>
        <el-breadcrumb-item>编辑场馆</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div>
        <el-form v-loading="formLoading" ref="stadiumForm" :model="listParams" :rules="checkListParams" label-width="150px">
          <el-form-item label="场馆名称：" prop="stadiumName">{{ listParams.stadiumName }}</el-form-item>

          <el-form-item label="场馆地址：" prop="stadiumAddress">{{ listParams.stadiumAddress }}</el-form-item>

          <el-form-item label="联系电话：" prop="mobile">
            <el-input size="small" placeholder="请填写联系电话" v-model="listParams.mobile"> </el-input>
          </el-form-item>

          <el-form-item label="场馆图片：" prop="stadiumImgs">
            <div class="upload-thumbnail-img" :loading="uploading">
              <i class="el-icon-circle-plus-outline upload-icon"></i>
              <input type="file" class="hidden-upload" @change="doUpload" id="uploadDom" />
            </div>
            <div class="wrap-thumbnail-img" v-if="listParams.stadiumImgs.length > 0">
              <div class="thumbnail-img" v-for="(item, index) in listParams.stadiumImgs" :key="index">
                <div class="combined-img">
                  <img :src="item" alt="" class="thumbnail-img-wrapped" :key="index" />
                  <div class="hover-img">
                    <i class="el-icon-circle-close-outline close-btn" @click="deleteImg(index)"></i>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="营业时间：" prop="businessTime">
            <div v-for="(item, index) in listParams.businessTime" :key="index">
              <el-time-select
                size="small"
                placeholder="起始时间"
                v-model="listParams.businessTime[index][0]"
                :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '22:30'
                }"
              >
              </el-time-select>
              <el-time-select
                size="small"
                placeholder="结束时间"
                v-model="listParams.businessTime[index][1]"
                :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '22:30',
                  minTime: listParams.businessTime[index][0]
                }"
              >
              </el-time-select>
              <el-button type="text" size="small" v-if="index !== 0" @click="deleteTimeQuantum(index)">
                删除
              </el-button>
            </div>
            <el-button size="small" type="primary" @click="addTimeQuantum">
              +增加时间段
            </el-button>
          </el-form-item>

          <el-form-item label="场馆介绍：" prop="introduce">
            <RichTextarea class="wang-editor-style" v-model="listParams.introduce" height="540px" />
          </el-form-item>

          <el-form-item label=" ">
            <div class="align-center mgt30">
              <el-button size="small" type="primary" :disabled="isDisabled" @click="saveEdit('stadiumForm')">
                保存
              </el-button>
              <el-button size="small" @click="backToListPage">
                返回
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      id: "",
      formLoading: false,
      listParams: {
        stadiumType: "",
        stadiumId: "",
        stadiumName: "",
        stadiumAddress: "",
        mobile: "",
        stadiumImgs: [],
        businessTime: [["", ""]],
        introduce: ""
      },
      checkListParams: {
        mobile: [{ required: true, message: "请填写联系电话", trigger: "blur" }],
        stadiumImgs: [
          {
            required: true,
            message: "请至少上传一张场馆图片",
            trigger: "change"
          }
        ],
        introduce: [{ required: true, message: "请填写场馆介绍", trigger: "blur" }]
      },
      uploading: false,
      isDisabled: false
    };
  },
  mounted() {
    this.loadDetailData(this.$route.query.id);
  },
  methods: {
    /**
     * 加载详情页数据
     */
    loadDetailData(id) {
      this.formLoading = true;
      this.$http({
        url: global.apiUrl + "/stadium/detail?stadiumId=" + id,
        methods: "GET"
      })
        .then((res) => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.formLoading = false;
            const resData = res.body.data;
            for (const i in resData) {
              this.listParams[i] = resData[i];
            }
            if (this.listParams.businessTime.length === 0) {
              this.listParams.businessTime = [["", ""]];
            }
          } else {
            this.formLoading = false;

          }
        })
        .catch((err) => {
          this.formLoading = false;

          console.error(err);
        });
    },
    /**
     * 上传图片
     */
    doUpload() {
      this.uploading = true;
      const files = document.getElementById("uploadDom").files;
      const file = files[0];
      const params = new FormData();
      params.append("file", file);
      params.append("path", "upload/good-img");
      Vue.ajaxPost(this, global.apiImageUpload + "/oss/image/upload", params, { "Content-Type": "multipart/form-data" })
        .then((res) => {
          this.uploading = false;
          this.listParams.stadiumImgs.push(res.data.data);
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    /**
     * 删除图片
     * @param index
     */
    deleteImg(index) {
      this.listParams.stadiumImgs.splice(index, 1);
    },
    /**
     * 删除时间段
     * @param index
     */
    deleteTimeQuantum(index) {
      this.listParams.businessTime.splice(index, 1);
    },
    /**
     * 增加时间段
     */
    addTimeQuantum() {
      if (this.listParams.businessTime.length >= 3) {
        this.$message.error("最多只能有三个时间段");
      } else {
        this.listParams.businessTime.push(["", ""]);
      }
    },
    /**
     * 保存修改的内容
     * @param name
     */
    saveEdit(name) {
      this.isDisabled = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          const bodyParams = Object.assign({}, this.listParams, {
            id: this.$route.query.id
          });
          bodyParams.stadiumType = parseInt(this.$route.params.stadiumType);
          bodyParams.stadiumId = parseInt(this.$route.params.stadiumId);
          this.$http({
            url: global.apiUrl + "/stadium/update",
            method: "PUT",
            body: bodyParams
          })
            .then((res) => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.isDisabled = false;
                this.$message.success(res.body.info);
                this.backToListPage();
              } else {
                this.isDisabled = false;

              }
            })
            .catch((err) => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 返回场馆信息列表页
     */
    backToListPage() {
      this.$router.push({
        name: "stadiumInfo"
      });
    }
  }
};
</script>

<style lang="less" scoped>
.hx-form-container {
  .wang-editor-style {
    width: 100%;
  }
  .upload-thumbnail-img,
  .thumbnail-img {
    width: 100px;
    height: 50px;
    border: 1px solid #ebeef5;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
    .upload-icon {
      font-size: 20px;
      display: inline-block;
      margin-top: 15px;
      margin-left: 40px;
    }
    .hidden-upload {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      filter: alpha(opacity=0); //filter 过滤器   兼容IE678
      z-index: 2;
      cursor: pointer;
    }
    .thumbnail-img-wrapped {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .combined-img {
      position: relative;
      width: 100px;
      height: 50px;
      .hover-img {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 999;
        opacity: 0;
        .close-btn {
          font-size: 22px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -11px;
          top: 50%;
          margin-top: -11px;
        }
      }
      .hover-img:hover {
        opacity: 1;
        cursor: pointer;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
  }
  .wrap-thumbnail-img {
    width: 100%;
    height: 50px;
    margin-top: 10px;
    display: flex;
  }
}
</style>
